import AbstractAPI from '@/services/api/AbstractAPI';

export default class NotificationApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/notification');
  }

  async getNew() {
    return this.makeRequest('/new', 'get');
  }

  async clearAll() {
    return this.makeRequest('/read', 'put');
  }

  async clear(id) {
    return this.makeRequest(`/read/${id}`, 'put');
  }

  async clearSystem(id) {
    return this.makeRequest(`/read-system/${id}`, 'put');
  }
}
